module.exports = __webpack_public_path__ + "img/invitationEn.e4e53214.jpg";